import {
  Component,
  HostListener,
  OnDestroy,
  ElementRef,
  Input,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
} from '@angular/forms';

import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule, Location } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { filter, Subscription } from 'rxjs';
import { BreadcrumbService } from '../services/breadcrumbs.service';
import { UserProfileService } from '../../features/users/profile.service';


@Component({
  selector: 'app-header',
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatButtonModule,
    RouterModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @Input() collapsed!: boolean;
  @Output() collapsedChange = new EventEmitter<boolean>();

  isDropdownOpen = false;
  breadcrumbs: Array<any> = [];
  private subscriptions = new Subscription();
  userName: any = '';
  userRole: any = '';

  //additonal
  url: string = '';

  constructor(
    private elementRef: ElementRef,
    private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private userProfileService: UserProfileService,
  ) {}

  ngOnInit(): void {
    this.getUserProfile();
    /////addition
    this.authService.isLoggedIn().subscribe((loggedIn) => {
      if (loggedIn) {
        this.getUserProfile();
      }
    });
    /////
    this.getProfileDetails();
    this.subscriptions.add(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          this.breadcrumbs = this.breadcrumbService.getBreadcrumbs();
        })
    );

    this.subscriptions.add(
      this.userProfileService.refreshProfile$.subscribe(() => {
        this.getUserProfile();
      })
    );
  }

  goBack(): void {
    if (this.breadcrumbs.length > 1) {
      const previousBreadcrumb = this.breadcrumbs[this.breadcrumbs.length - 2];
      this.router.navigate([previousBreadcrumb.path]);
    }
  }

  shouldShowBackButton(): boolean {
    return this.breadcrumbs.length > 1;
  }

  toggleChange() {
    this.collapsedChange.emit(!this.collapsed);
  }

  toggleDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  onMyProfile() {
    this.router.navigate([`profile`]);
  }

  logout() {
    this.authService.logout();
  }

  getProfileDetails() {
    const checkInterval = setInterval(() => {
      const name = sessionStorage.getItem('userName');
      const role = sessionStorage.getItem('userRole');
      if (name && role) {
        this.userName = name;
        this.userRole = role;
        clearInterval(checkInterval);
      }
    }, 100);
  }

  getUserProfile() {
    const authToken = sessionStorage.getItem('AUTH_TOKEN');
    if(!authToken){
      return;
    }
    this.authService.getUserProfile().subscribe({
      next: (res) => {
        let imageUrl = res.data.admin?.profilePic;
        this.url = imageUrl? imageUrl : 'assets/images/profile.jpg'
      },
      error: (err) => {
        console.error('error:', err);
      },
    });
  }
}
